/**
 * The last few API calls that failed, kept in memory for a bug report (EP-53, decision 10).
 *
 * <p>What is kept is what finds the call in the logs — method, path, status, the problem's `code`
 * and the `X-Request-Id` the backend exposes — and nothing of what it carried: no query string (it may
 * hold a search for a customer's name), no body, no headers. Nothing is persisted: a reload empties
 * the list, which is what "recent" means.
 */
export interface ApiFailure {
  method: string;
  path: string;
  status: number;
  code?: string;
  requestId?: string;
  at: string;
}

const LIMIT = 5;
const failures: ApiFailure[] = [];
const listeners = new Set<(failure: ApiFailure) => void>();

export function recordApiFailure(failure: ApiFailure): void {
  failures.unshift(failure);
  failures.length = Math.min(failures.length, LIMIT);
  listeners.forEach((listener) => listener(failure));
}

/** Hears every failure as it happens — the roastery app offers "Report" on a 5xx (EP-53). */
export function onApiFailure(listener: (failure: ApiFailure) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Newest first, as a copy: the report takes a picture of the list, not a reference to it. */
export function recentApiFailures(): ApiFailure[] {
  return failures.map((failure) => ({ ...failure }));
}
